<template>
  <div class="main-layout" :class="{ 'light-theme': !isDarkTheme, 'dark-theme': isDarkTheme }">
    <!-- Header -->
    <MainHeader></MainHeader>
    
    <!-- Contenido Principal -->
    <main class="main-content">
      <slot></slot>
    </main>
    
    <!-- Footer -->
    <app-footer></app-footer>
  </div>
</template>

<script>
import MainHeader from '@/components/Sections/MainHeader.vue';
import AppFooter from '@/components/Sections/Footer.vue';

export default {
  name: 'MainLayout',
  components: {
    MainHeader,
    AppFooter
  },
  data() {
    return {
      isDarkTheme: false
    }
  },
  provide() {
    return {
      theme: this.themeData
    }
  },
  computed: {
    themeData() {
      return {
        isDarkTheme: this.isDarkTheme,
        toggleTheme: this.toggleTheme
      }
    }
  },
  mounted() {
    // Cargar preferencia de tema desde localStorage
    const savedTheme = localStorage.getItem('appTheme');
    if (savedTheme) {
      this.isDarkTheme = savedTheme === 'dark';
    }
    // Aplicar tema inicial al document
    this.applyTheme();
    
    // Escuchar eventos de cambio de tema (para compatibilidad con código existente)
    window.addEventListener('theme-changed', this.handleThemeChange);
  },
  beforeDestroy() {
    window.removeEventListener('theme-changed', this.handleThemeChange);
  },
  watch: {
    // Observar cambios en el tema para aplicarlos globalmente
    isDarkTheme() {
      this.applyTheme();
    }
  },
  methods: {
    toggleTheme() {
      this.isDarkTheme = !this.isDarkTheme;
      localStorage.setItem('appTheme', this.isDarkTheme ? 'dark' : 'light');
      // Emitir evento global para componentes que aún lo usen
      window.dispatchEvent(new CustomEvent('theme-changed', { 
        detail: { isDarkTheme: this.isDarkTheme } 
      }));
    },
    applyTheme() {
      // Aplicar clase al documentElement para que afecte globalmente
      if (this.isDarkTheme) {
        document.documentElement.classList.remove('light-theme');
        document.documentElement.classList.add('dark-theme');
      } else {
        document.documentElement.classList.remove('dark-theme');
        document.documentElement.classList.add('light-theme');
      }
    },
    handleThemeChange(event) {
      // Sincronizar si el tema cambia desde otro componente
      this.isDarkTheme = event.detail.isDarkTheme;
    }
  }
}
</script>

<style scoped>
.main-layout {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: var(--theme-bg-primary);
  transition: background-color 0.3s ease, color 0.3s ease;
}

.main-content {
  flex: 1 0 auto;
  background: transparent;
}
</style>
